import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ThfDynamicFormField } from '@totvs/thf-ui';

@Component({
  selector: 'thf-page-job-scheduler-parameters',
  templateUrl: 'thf-page-job-scheduler-parameters.component.html'
})
export class ThfPageJobSchedulerParametersComponent implements AfterViewInit {

  @ViewChild('parametersForm', { static: true }) form: NgForm;

  @Input('t-literals') literals = <any> {};

  @Input('t-parameters') parameters: Array<ThfDynamicFormField> = [];

  @Input('t-value') value;

  @Output('t-valueChange') valueChange: EventEmitter<any> = new EventEmitter<any>();

  ngAfterViewInit() {
    if (this.form) {
      setTimeout(() => {

        this.form.valueChanges.subscribe(value => {
          this.valueChange.emit(value);
        });

      });
    }
  }

}
